export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 9_08.69f4c4a3.jpg";